<div class="totem">
    <header>
        <div class="header-title">
            <h1 *ngIf="authenticated" class="header__h1">{{totemName}}</h1>
            <h3 *ngIf="authenticated" class="header__h3">{{healthUnitStruct? healthUnitStruct.healthUnitName : null}}</h3>
        </div>
        <div class="header-logo">
            <div class="header-logo-content">
                <img *ngIf="totemStruct.isLogoUploaded" class="brand" [src]="clientLogo">
                <img class="brand" src="assets/images/logo-colorida.png">
            </div>
        </div>
    </header>
    <div class="totem-body">
        <div *ngIf="!onlineOffline" class="offline">
            <span><mat-icon class="offline--icon">wifi_off</mat-icon>Você esta sem conexão com a internet no momento.</span>
        </div>
        <app-pin-totem *ngIf="!authenticated" (onAuthenticated)="checkPin($event)" [isLoading]="isLoading"></app-pin-totem>
        <app-totem-options *ngIf="authenticated && !finished" (onFinish)="finish($event)" [listPriority]="listPriority"
            [listTotemPriority]="listTotemPriority" [listTotemButton]="listTotemButton" [state]="state"
            [timeZoneValue]="timeZoneValue" [isLoading]="isLoading" [idHealthUnit]="idHealthUnit"
            [hasFacialBiometrics]="healthUnitStruct.hasFacialBiometrics && totemStruct.useFacialBiometrics"
            (populatePriorities)="getTotemPriority()">
        </app-totem-options>
        <app-totem-success *ngIf="authenticated && finished"
            [generateEpisodeResponse]="generateEpisodeResponse"></app-totem-success>
    </div>
    
    <footer class="footer-logo-content">
        <img class="brand" src="assets/images/simple-logo-green.png">
    </footer>
</div>
<div class="media-overlay" [ngStyle]="{'display': isIdle && mediaSources.length > 0 ? 'block' : 'none'}">
    <span class="subtitle">Presisone qualquer botão para continuar</span>
    <app-media-display [mediaSources]="mediaSources" [refreshTime]="mediaSourceExpirationTime"></app-media-display>
</div>